// import Certificado from './Index.vue'
import Permissions from "../../models/Permissions";

const SpedFiscal = () => import("./Index.vue");

const permissions = [
  Permissions.COLABORADOR,
  Permissions.GESTOR,
  Permissions.ADMINISTRADOR,
];

export default [
  {
    path: "/SpedFiscal",
    name: "SpedFiscal",
    component: SpedFiscal,
    meta: {
      requiresAuth: true,
      requiresCompany: true,
      showInMenu: true,
      label: "SPED Fiscal",
      icon: "fa fa-file",
      group: "SPEDS / DeSTDA",
      permissions,
    },
  },
];
